module.exports = __webpack_public_path__ + "img/icon-player-mode.e2f78e3a.svg";